import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getLiveCallTasks,
  markTaskComplete,
} from "app/services/liveCallTasks/liveCallTasks.service";
import { BASE_URL } from "static/constants";

export const liveCallTasksApi = createApi({
  reducerPath: "liveCallTasksApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query, mutation }) => ({
    getLiveCallTasks: query({
      queryFn: (query) => {
        return {
          data: getLiveCallTasks(query),
        };
      },
      providesTags: ["liveCallTasks"],
    }),
    markTaskComplete: mutation({
      queryFn: ({ taskId, reason, completionDate }) => {
        return {
          data: markTaskComplete({ taskId, reason, completionDate }),
        };
      },
      invalidatesTags: ["liveCallTasks"],
    }),
  }),
});

export const { useGetLiveCallTasksQuery, useMarkTaskCompleteMutation } =
  liveCallTasksApi;
